import type * as Types from 'app/types/graphql';

export type UsageFeeCurrentSelectFragment = Pick<
  Types.UsageFeeCurrent,
  'currencyCode' | 'cycleEndDate' | 'cycleStartDate' | 'price' | 'tierID' | 'usageAmount'
> & { revenue?: Types.Maybe<Pick<Types.ShopPlatformRevenue, 'id' | 'date' | 'totalRevenue'>> };

export const UsageFeeCurrentSelectFragmentDoc = `
    fragment UsageFeeCurrentSelect on UsageFeeCurrent {
  currencyCode
  cycleEndDate
  cycleStartDate
  price
  revenue {
    ...ShopPlatformRevenueSelect
  }
  tierID
  usageAmount
}
    `;
